import React from 'react';
import {
  Box,
} from '@mui/material';
import SalesFunnelOverview from './agent_report/SalesFunnelOverview';
import CallPerformanceSummary from './agent_report/CallPerformanceSummary';
import CallsByAgentChart from './agent_report/CallsByAgentChart';
import TeamLeaderboard from './agent_report/TeamLeaderboard';

const AgentReportPage = ({ dateRangeState, periodType, selectedTeams = [], teams = [] }) => {

  return (
    <Box
      sx={{
        flexGrow: 1,
        pt: 0,
        pb: 3,
        px: { xs: 2, sm: 3 },
      }}
    >
      {/* Content Sections */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
          <Box sx={{ flex: 1, minWidth: { xs: '100%', md: '400px' } }}>
            <SalesFunnelOverview dateRangeState={dateRangeState} periodType={periodType} />
          </Box>
          <Box sx={{ flex: 1, minWidth: { xs: '100%', md: '400px' } }}>
            <CallPerformanceSummary dateRangeState={dateRangeState} periodType={periodType} />
          </Box>
        </Box>
        <CallsByAgentChart dateRangeState={dateRangeState} periodType={periodType} />
        <TeamLeaderboard dateRangeState={dateRangeState} periodType={periodType} />
      </Box>
    </Box>
  );
};

export default AgentReportPage;
